import { useLocation } from 'react-router-dom';

/**
 * Grabs the keys/values passed in via the URL query. (i.e. https://APP_URL?key=value)
 * Returns them all in a plain object of strings. e.g. `{key: value}`
 */
const useSearchParams = <T extends Record<string, string>>(): T => {
  const { search } = useLocation();
  return search
    .replace('?', '')
    .split('&')
    .reduce((acc, cur) => {
      const split = cur.split('=');
      const key = split[0];
      const value = split[1];

      return key ? { ...acc, [key]: value } : acc;
    }, {}) as T;
};

export default useSearchParams;
